import Logo from '../../assets/images/logo.svg';
import "./login.scss";
import { Button, Row, Col, Input } from 'reactstrap';
import { useEffect, useRef, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WebService from "../../Services/WebService";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";

const VerifyOtp = () => {
    const {
        formState: { errors },
    } = useForm({ mode: "onChange" });

    const [error, setError] = useState<any>(false);
    const [loading, setLoading] = useState<any>(false);
    const [resendLoading, setResendLoading] = useState(false);
    const history = useNavigate();
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const location = useLocation();
    const [code, setCode] = useState(['', '', '', '', '', '']);
    const [isCountdownEnded, setIsCountdownEnded] = useState(false);
    const [counter, setCounter] = useState<number>(60);
    const firstInputRef = useRef<HTMLInputElement | null>(null);

    const [email] = useState(location.state?.email);
    const handleInputChange = (value: any, index: any) => {
        const newCode = [...code];
        newCode[index] = value;
        setCode(newCode);

        if (value && index < 5) {
            document.getElementById(`code-input-${index + 1}`)?.focus();
        }
    };
    useEffect(() => {
        startCounter(counter);
    }, [counter]);
    useEffect(() => {
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, []);
    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);

    const handleConfirm = () => {
        const enteredCode = code.join('');
        if (enteredCode.length !== 6) {
            toast.error('Please enter OTP which is sent to your email');
            return;
        }
        if (isCountdownEnded) {
            toast.error("Your time has expired. Please click 'Resend OTP' to get a new code.");
            return;
        }
        setLoading(true);
        WebService.postAPI({
            action: `/verify_otp`,
            body: { otp: enteredCode, email: email },
        })
            .then((res: any) => {
                if (res) {
                    toast.success(res.message)
                    setLoading(false);
                    if (res.token) {
                        localStorage.setItem("authToken", res.token)
                    }
                    history('/set-password',)
                }
            })
            .catch((e) => {
                setLoading(false);
                toast.error(e?.response?.data?.message);
            });
    };
    const resendOtp = () => {
        setResendLoading(true);
        setCode(['', '', '', '', '', '']);
        let obj = { "email": email, "type": "ADMIN" };

        WebService.postAPI({
            action: `/resend_otp`,
            body: obj,
        })
            .then((res: any) => {
                toast.success(res.message);
                const newTimer = res.expired_time || 60;
                setCounter(newTimer);
                startCounter(newTimer);
                setResendLoading(false);
                if (firstInputRef.current) {
                    firstInputRef.current.focus();
                }
            })
            .catch((e) => {
                setError(true);
                toast.error(e?.response?.data?.message);
                setResendLoading(false);
            });
    };
    const handleKeyDown = (event: any, index: number) => {
        if (event.key === 'Backspace' && !code[index]) {
            if (index > 0) {
                document.getElementById(`code-input-${index - 1}`)?.focus();
            }
        }
    };

    function startCounter(time: number) {
        setIsCountdownEnded(false);
        setCounter(time);
        if (timerRef.current) {
            clearInterval(timerRef.current);
        }

        timerRef.current = setInterval(() => {
            setCounter((prev) => {
                if (prev <= 1) {
                    if (timerRef.current) clearInterval(timerRef.current);
                    setIsCountdownEnded(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    }

    const counterView = useMemo(() => {
        return <span className="font-medium">00:{String(counter).padStart(2, '0')}</span>;
    }, [counter]);
    return (
        <>
            <div className="login-page">
                <div className="row justify-content-center min-vh-100 align-items-center mx-0">

                    <div className="col-lg-5 d-flex align-items-center justify-content-center">
                        <div className="w-75 login-card rounded-4">
                            <div className="px-lg-5 px-3 py-5">
                                <div className="text-center  mb-4">
                                    <img src={Logo} width="100" alt="Logo" />
                                </div>
                                <Row className="justify-content-center mb-4">
                                    {code.map((digit, index) => (
                                        <Col key={index} xs="2" className="text-center">
                                            <Input
                                                id={`code-input-${index}`}
                                                type="text"
                                                value={digit}
                                                innerRef={index === 0 ? firstInputRef : null}
                                                onChange={(e) => handleInputChange(e.target.value, index)}
                                                onKeyDown={(e) => {
                                                    handleKeyDown(e, index);
                                                    if (e.key === "Enter" && index === 5) {
                                                        handleConfirm();
                                                    }
                                                }}
                                                className="text-center border-primary"
                                            />
                                        </Col>
                                    ))}
                                </Row>
                                {!isCountdownEnded && (
                                    <p aria-disabled className='text-center' style={{ color: "red" }}>
                                        {counterView}
                                    </p>
                                )}
                                <p className="text-brand font-13 d-flex justify-content-end mb-4 cursor-pointer">
                                    <a onClick={() => resendOtp()} href="#" style={{ color: "#007bff", textDecoration: "none" }}>
                                        {resendLoading ? (
                                            <Spinner size="sm" className="me-2">Loading...</Spinner>
                                        ) : null}
                                        Resend OTP
                                    </a>
                                </p>
                                <div className="col-lg-12 mt-4 text-center">
                                    <Button type="submit" className="btn btn-brand-1 w-100" onClick={handleConfirm}>
                                        {error ? null : loading ? (
                                            <Spinner size="sm" className="me-2">Loading...</Spinner>
                                        ) : null}
                                        Confirm Code
                                    </Button>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div >
        </>
    )

}
export default VerifyOtp;